import XLSX from 'xlsx';

export default function readFileXlsx(file, allSheet = false) {
  return new Promise((resolve) => {
    const fileReader = new FileReader();
    let rsltFile = null;
    fileReader.onload = (async e => {
      let binary = '';
      const bytes = new Uint8Array(e.target.result);
      const length = bytes.byteLength;
      for (let i = 0; i < length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      const oFile = await XLSX.read(binary, { type: 'binary', cellDates: true, cellStyles: true });
      if (allSheet) {
        const result = [];
        oFile.SheetNames.forEach(el => {
          const ws = XLSX.utils.sheet_to_json(oFile.Sheets[el]);
          result.push(ws);
        });
        rsltFile = result;
      } else {
        rsltFile = XLSX.utils.sheet_to_json(oFile.Sheets[oFile.SheetNames[0]]);
      }
      resolve(rsltFile);
    });
    fileReader.readAsArrayBuffer(file.file);
  });
}
